import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { AdminProductsActions } from "../../actions/admin-products.actions";
import { FamilyAttributesState } from "../../models/mp-admin/family-attributes-state";

const initialState: FamilyAttributesState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(AdminProductsActions.familyAttributes.getApi, (state) => ({
		...state,
		loading: true
	})),
	on(AdminProductsActions.familyAttributes.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		...action.state,
		loading: false
	})),
	on(AdminProductsActions.familyAttributes.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(AdminProductsActions.familyAttributes.invalidate, () => initialState)
);

export function familyAttributesReducer(
	state: FamilyAttributesState | undefined,
	action: Action
): FamilyAttributesState {
	return reducer(state, action);
}
